/* eslint-disable @typescript-eslint/no-unused-vars */
import {
	BorderLinearProgress,
	Container,
	Counter,
	TextContainer
} from "./styles";

interface Props {
	isCurrentTierActive: boolean;
	currentProgress: number;
	totalProgress: number;
}

export const ProgressBar = ({
	isCurrentTierActive,
	currentProgress,
	totalProgress
}: Props) => {
	const isInitialState = totalProgress === 0;

	return (
		<Container>
			<BorderLinearProgress
				variant="determinate"
				value={isInitialState ? 0 : (currentProgress * 100) / totalProgress}
			/>
			<TextContainer
				style={{
					color: isCurrentTierActive ? "#fff" : "#C4C4C4"
				}}
			>
				<Counter>
					{isInitialState
						? "Rebate Offer!"
						: `${currentProgress}/${totalProgress}`}
				</Counter>
			</TextContainer>
		</Container>
	);
};
